module.exports = require("lodash/throttle");